<template>
  <div class="d-flex align-center my-2 mr-3">
    <UrlAutocompleter
      :initial-urls="initialEntries"
      @changed="onChanged"
    />
    <v-text-field
      @keydown.enter.prevent="submit"
      :label="$t('journal.search.criterias.url.score')"
      class="ml-2"
      style="width: 150px; max-width: 150px;"
      hide-details
      dense
      outlined
      type="number"
      v-model="multiplier"
      :rules="rules"
    />
  </div>
</template>
<script>
import { nanoid } from 'nanoid';
import { criterias } from '../SearchCriteria';
import UrlAutocompleter from './UrlAutocomplete';

export default {
  name: 'UrlScore',
  components: { UrlAutocompleter },
  props: {
    params: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    initialEntries: [],
    entries: [],
    isLoading: false,
    multiplier: 1.0,
    include: true,
    id: `${criterias.URL_SCORE}/${nanoid(10)}`,
    rules: [
      v => (v && v.length !== 0) || 'Ce champs ne peut être vide',
    ],
  }),
  created() {
    if (this.params !== undefined) {
      const data = this.params.scorings[0].Url;
      this.id = data.id;
      this.initialEntries = [...data.param];
      this.model = data.param;
      this.multiplier = Number.parseFloat(data.multiplier);
    }
  },
  computed: {
    items() {
      return [...this.entries];
    },
  },
  methods: {
    onChanged(event) {
      this.entries = [...event];
    },
    submit() {
      this.$emit('submit');
    },
    getCriteria() {
      return {
        scorings: [
          {
            Url: {
              param: this.entries,
              multiplier: Number.parseFloat(this.multiplier),
              id: this.id,
            },
          },
        ],
      };
    },
  },
};
</script>
